import axios from 'axios';
import apiUrl from '../../constants';

export function getHubdropdownlist(token){
  return axios({
    method: 'post',
    url: apiUrl.api_url + 'getHubdropdownlist',
    data: {},
    headers: {
      'Authorization': 'Bearer ' + token
    }
  });
  }
  export function getZoneList(token){
    return axios({
      method: 'post',
      url: apiUrl.api_url + 'getZoneList',
      data: {},
      headers: {
        'Authorization': 'Bearer ' + token
      }
    });
    }


// WEBPACK FOOTER //
// ./src/services/B2BModule/HubZoneDataAPI.js